<template>
  <div class="modal-overlay">
    <div class="modal">
      <div class="close-modal" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'xmark']" size="lg" style="color: #676879;" />
      </div>
      <h2 style="margin-top: 0; margin-bottom: 1rem;">
        {{ $t("intensity.deleteConfirm") }}
      </h2>

      <div class="snackbar alert">
        <div class="letter-circle">!</div>
        <div>
          {{ $t("intensity.deleteConfirmDetail") }}
        </div>
      </div>

      <div class="flex right margin-top">
        <div class="bold pointer" @click="$emit('close')">
          {{ $t("general.cancel") }}
        </div>
        <div class="blue-button" @click="$emit('deleteIntensity', intensity)">
          {{ $t("general.confirm") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import instance from '../../main';


export default {
  components: {
  },
  props: {
    intensity: String
  },
  data() {
    return{

    }
  },
  async mounted() {

  },
  computed: {

  },
  methods: {


  },
  created() {

  }
}

</script>
